import { createSlice } from "@reduxjs/toolkit";
import { UploadedDocumentsPreview } from "../types";
import { fetchUploadedDocuments } from "./thunk/UploadDocumentsThunk";

// Thunk to simulate API call

const initialState: UploadedDocumentsPreview = {
  uploadDocuments: [],
  loading: false,
  error: null,
};

const UploadedDocumentsSlice = createSlice({
  name: "uploadedDocuments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUploadedDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUploadedDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadDocuments = action.payload;
      })
      .addCase(fetchUploadedDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Something went wrong";
      });
  },
});

export default UploadedDocumentsSlice.reducer;
